import { render, staticRenderFns } from "./productsIntroduction.vue?vue&type=template&id=0bae9924&"
import script from "./productsIntroduction.vue?vue&type=script&lang=js&"
export * from "./productsIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./productsIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports